export const INITIATE_GET_IMPORT_MAPPINGS = 'INITIATE_GET_IMPORT_MAPPINGS';
export const GET_IMPORT_MAPPINGS_SUCCESS = 'GET_IMPORT_MAPPINGS_SUCCESS';
export const GET_IMPORT_MAPPINGS_FAILURE = 'GET_IMPORT_MAPPINGS_FAILURE';

export const INITIATE_START_IMPORT_ORDERS = 'INITIATE_START_IMPORT_ORDERS';
export const START_IMPORT_ORDERS_SUCCESS = 'START_IMPORT_ORDERS_SUCCESS';
export const START_IMPORT_ORDERS_FAILURE = 'START_IMPORT_ORDERS_FAILURE';

export const SET_SELECTED_IMPORT_STORE_GUID = 'SET_SELECTED_IMPORT_STORE_GUID';
export const SET_ORDER_IMPORT_MAPPING_NAME = 'SET_ORDER_IMPORT_MAPPING_NAME';
export const OPEN_ORDER_IMPORT_MAPPING_MODAL = 'OPEN_ORDER_IMPORT_MAPPING_MODAL';
export const ORDER_IMPORT_MAPPING_MODAL_OPENED = 'ORDER_IMPORT_MAPPING_MODAL_OPENED';
export const ORDER_IMPORT_PROGRESS_NOTIFICATION_OPENED = 'ORDER_IMPORT_PROGRESS_NOTIFICATION_OPENED';
export const OPEN_MAPPINGS_MANAGER_MODAL = 'OPEN_MAPPINGS_MANAGER_MODAL';
export const OPEN_MAPPINGS_DELETE_MODAL = 'OPEN_MAPPINGS_DELETE_MODAL';

export const INITIATE_ORDERS_CSV_UPLOAD = 'INITIATE_ORDERS_CSV_UPLOAD';
export const UPLOAD_ORDERS_CSV_SUCCESS = 'UPLOAD_ORDERS_CSV_SUCCESS';
export const UPLOAD_ORDERS_CSV_FAILURE = 'UPLOAD_ORDERS_CSV_FAILURE';

export const RENAME_SAVED_IMPORT_MAPPING = 'RENAME_SAVED_IMPORT_MAPPING';
export const RENAME_SAVED_IMPORT_MAPPING_FAILURE = 'RENAME_SAVED_IMPORT_MAPPING_FAILURE';
export const DELETE_SAVED_IMPORT_MAPPING = 'DELETE_SAVED_IMPORT_MAPPING';

export const GET_ORDER_IMPORT_STATUS_LOG_SUCCESS = 'GET_ORDER_IMPORT_STATUS_LOG_SUCCESS';
export const GET_ORDER_IMPORT_STATUS_LOG_FAILURE = 'GET_ORDER_IMPORT_STATUS_LOG_FAILURE';

export const startFileImport = (mappingsPayload) => ({
  type: INITIATE_START_IMPORT_ORDERS,
  mappingsPayload,
});

export const fileImportSuccess = (response) => ({
  type: START_IMPORT_ORDERS_SUCCESS,
  response,
});

export const fileImportFailure = (error) => ({
  type: START_IMPORT_ORDERS_FAILURE,
  error,
});

export const renameSavedMapping = (mappingName, updatedName) => {
  return {
    type: RENAME_SAVED_IMPORT_MAPPING,
    mappingName,
    updatedName,
  };
};

export const renameSavedMappingError = (error) => ({
  type: RENAME_SAVED_IMPORT_MAPPING_FAILURE,
  error,
});

export const getMappings = () => ({
  type: INITIATE_GET_IMPORT_MAPPINGS,
});

export const getMappingSuccess = (response) => {
  return {
    type: GET_IMPORT_MAPPINGS_SUCCESS,
    response,
  };
};

export const getMappingFailure = (error) => ({
  type: GET_IMPORT_MAPPINGS_FAILURE,
  error,
});

export const setStoreGuid = (storeGuid) => ({
  type: SET_SELECTED_IMPORT_STORE_GUID,
  storeGuid,
});

export const setMappingName = (mappingName) => ({
  type: SET_ORDER_IMPORT_MAPPING_NAME,
  mappingName,
});

export const openOrderImportMappingsModal = () => {
  return {
    type: OPEN_ORDER_IMPORT_MAPPING_MODAL,
  };
};

export const openOrderImportMappingsManagerModal = () => {
  return {
    type: OPEN_MAPPINGS_MANAGER_MODAL,
  };
};

export const openOrderImportMappingsDeleteModal = (mappingName) => {
  return {
    type: OPEN_MAPPINGS_DELETE_MODAL,
    mappingName,
  };
};

export const orderImportMappingModalOpened = (modalId) => {
  return {
    type: ORDER_IMPORT_MAPPING_MODAL_OPENED,
    modalId,
  };
};

export const orderImportProgressNotificationOpened = (notificationId) => {
  return {
    type: ORDER_IMPORT_PROGRESS_NOTIFICATION_OPENED,
    notificationId,
  };
};

export const deleteSavedMapping = (mappingName) => {
  return {
    type: DELETE_SAVED_IMPORT_MAPPING,
    mappingName,
  };
};

export const upload = (mappingName, hasColumnHeaders, file) => {
  return {
    type: INITIATE_ORDERS_CSV_UPLOAD,
    mappingName,
    hasColumnHeaders,
    file,
  };
};

export const uploadSuccess = (response) => ({
  type: UPLOAD_ORDERS_CSV_SUCCESS,
  response,
});

export const uploadFailure = (error) => ({
  type: UPLOAD_ORDERS_CSV_FAILURE,
  error,
});

export const orderImportStatusLogSuccess = (response) => ({
  type: GET_ORDER_IMPORT_STATUS_LOG_SUCCESS,
  response,
});

export const orderImportStatusLogFailure = (error) => ({
  type: GET_ORDER_IMPORT_STATUS_LOG_FAILURE,
  error,
});
